import { render, staticRenderFns } from "./MarcaClienteABM.vue?vue&type=template&id=2fad7254&"
import script from "./MarcaClienteABM.vue?vue&type=script&lang=js&"
export * from "./MarcaClienteABM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports